import { conversion, suggestions, trainer } from './ui-sync';
import { api, auth, backendEventFanout, errorsIntercepter, logger, lowCallVolumeReminder, snoozeTimer, user } from './backend-runtime';
import { audioDeviceConnections, audioSystemInfoConnection, callManager, forwardingConnection, mainConnection } from './io-connections';

export const uiMiddlewares = [conversion, suggestions, trainer];

export const backendMiddlewares = [
    auth,
    lowCallVolumeReminder,
    errorsIntercepter,
    api,
    backendEventFanout,
    mainConnection,
    forwardingConnection,
    audioSystemInfoConnection,
    audioDeviceConnections,
    user,
    callManager,
    snoozeTimer,
    logger
];

export default uiMiddlewares;
